import { anatomyConstants } from "../../../constants/anatomyConstants";

const DrillModal = ({
  brushSize,
  setBrushSize,
  drillShape,
  setDrillShape,
  closeDrillModal,
  isMobile,
}) => {
  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } flex flex-col space-y-3 p-3 bg-white text-gray-800 rounded-lg shadow-lg max-w-xs z-20`}
      style={{
        "--main-color": anatomyConstants.mainColor,
        "--main-color-bold": anatomyConstants.mainColorBold,
      }}
    >
      <div className="flex flex-col space-y-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeDrillModal();
          }}
          aria-label="Close"
          className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-100 border border-[#0000001A] shadow-sm flex items-center justify-center text-gray-700 hover:bg-gray-200 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <label className="text-sm font-medium">Drill Shape:</label>
        <div className="flex space-x-2">
          <button
            onClick={() => setDrillShape("circle")}
            className={`px-3 py-1 text-m rounded ${
              drillShape === "circle"
                ? "bg-[var(--main-color)] text-white hover:bg-[var(--main-color-bold)]"
                : "bg-gray-200 hover:[var(--main-color-bold)] text-gray-800"
            }`}
          >
            Circle
          </button>
          <button
            onClick={() => setDrillShape("square")}
            className={`px-3 py-1 text-m rounded ${
              drillShape === "square"
                ? "bg-[var(--main-color)] text-white hover:bg-[var(--main-color-bold)]"
                : "bg-gray-200 hover:[var(--main-color-bold)] text-gray-800"
            }`}
          >
            Square
          </button>
        </div>
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="brushSize" className="text-sm font-medium">
          Brush Size: {brushSize.toFixed(1)}
        </label>
        <input
          id="brushSize"
          type="range"
          min="0.1"
          max="5"
          step="0.1"
          value={brushSize}
          onChange={(e) => setBrushSize(parseFloat(e.target.value))}
          className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer slider accent-[var(--main-color)]"
        />
      </div>
    </div>
  );
};

export default DrillModal;
